<div class="modal-body" style="background-color:rgb(242, 242, 242);">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <ngb-progressbar type="dark" [value]="100" [striped]="true" [animated]="true"><i>Loading...</i></ngb-progressbar>
            </div>
        </div>
    </div>
</div>
